import { LEASE_OPTIONS_LABELS } from '../../common/enums';

export const LEASE_SELECT_INPUT_OPTIONS = Object.keys(LEASE_OPTIONS_LABELS).map(key => ({
  text: LEASE_OPTIONS_LABELS[key],
  value: key,
}));
